import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const navegacao = [
  { nome: "Home", href: "/" },
  { nome: "Sobre nós", href: "/sobre" },
];

export default function Navbar() {
  const [location] = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={cn(
        "fixed w-full z-50 transition-all duration-300",
        scrolled
          ? "bg-[#132034] bg-opacity-90 shadow-lg backdrop-blur-md"
          : "bg-[#132034]",
      )}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link href="/">
              <a className="flex items-center transition-all duration-300 hover:scale-105 brightness-200 hover:brightness-300">
                <img src="/Logotipo.png" alt="A Bordo Viagens" className="h-8" />
              </a>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navegacao.map((item) => (
              <Link key={item.nome} href={item.href}>
                <a
                  className={cn(
                    "font-['MontserratAlt1'] font-medium transition-all duration-300 relative py-2",
                    location === item.href
                      ? "font-['MontserratAlt1'] font-medium text-[#b3855e]"
                      : "font-['MontserratAlt1'] font-medium text-[#fcfcfb] hover:text-[#b3855e]",
                    "after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#b3855e] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300",
                  )}
                >
                  {item.nome}
                </a>
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#fcfcfb] hover:text-[#b3855e] transition-colors"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navegacao.map((item) => (
                <Link key={item.nome} href={item.href}>
                  <a
                    className={cn(
                      "block px-3 py-2 rounded-md text-base font-medium transition-colors",
                      location === item.href
                        ? "text-[#b3855e] bg-[#fcfcfb]/10"
                        : "text-[#fcfcfb] hover:text-[#b3855e] hover:bg-[#fcfcfb]/5",
                    )}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.nome}
                  </a>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}